<template>
  <tr :class="{'deleted': isDeleted}"
      @dblclick="$router.push( { name: 'resourcesEdit', params: {id:resourceId} })"
  >
    <td>
      <div class="btn-group"
           role="group"
      >
        <button v-if="$store.getters.currentUserHasAction('EDIT_RESOURCE')"
                type="button"
                class="asd-btn-edit"
                v-help.mouse="`Editovat zdroj`"
                @click="$router.push( { name: 'resourcesEdit', params: {id:resourceId} })"
        >
          <i class="fas fa-pencil-alt"></i>
        </button>
      </div>
    </td>
    <td>
      {{ resourceType.name }}
    </td>
    <td v-for="(prop, key) in propertiesToShow"
        :key="key"
        :class="{'empty-value': !prop}"
    >
      <template v-if="prop">
        <PropertyDetailProxy :id="key"
                             :key="key"
                             :value="prop"
        ></PropertyDetailProxy>
      </template>
      <template v-else>
      </template>
    </td>
  </tr>
</template>

<script>
import LangFilters from 'CORE/mixins/langFilters'
import ResourceDataMixin from 'CORE/mixins/resource-data'
import PropertyDetailProxy from 'CORE/components/data-type/property-detail-proxy'
import _ from 'lodash'

export default {
    name: 'ResourceRow',
    components: {
        PropertyDetailProxy,
    },
    mixins: [
        LangFilters,
        ResourceDataMixin,
    ],
    props: {
        resourceId: {
            type: String,
            required: true,
        },
        propsToShow: {
            type: Array,
            required: false,
            default: _ => ['system-name', 'system-creator'],
        },
    },
    computed: {
        propertiesToShow() {
            const pts = {}
            for (const p of this.propsToShow) {
                _.set(pts, p, _.get(this, `resource.propertyValues.${p}`))
            }
            return pts
        },
        isDeleted() {
            return !!_.get(this.resource, 'validUntil', false)
        },
    },
}
</script>
